import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Logout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      logout();
      setTimeout(() => {
        navigate('/');
      }, 100);
    }, [logout, navigate]);

    return (
      <div>
        <p>Cerrando sesión...</p>
      </div>
    );
  };

  export default Logout;